export default __webpack_public_path__ + "static/media/21t.cf1bc360.jpg";